import i18next from "../i18n";

const { t } = i18next;

/** Given an product ID, return a user-friendly name. */
export function productDisplayName(productId: string): string {
  switch (productId) {
    case "tram":
      return "TRAM";
    case "property-claim-handler":
      return t("product.property_claim_handler");
    case "auto-platform-product-portal":
      return t("product.auto_platform_product_portal");
    default:
      return productId;
  }
}
